interface SocialDictionary {
  [key: string]: {
    name: string;
    url: string;
  };
}

export const socialDictionary: SocialDictionary = {
  facebook: {
    name: "Facebook",
    url: "https://www.facebook.com/BrexHQ/",
  },
  youtube: {
    name: "Youtube",
    url: "https://www.youtube.com/channel/UCQQB8ThG8aBLvp50R0OcscA/",
  },
  instagram: {
    name: "Instagram",
    url: "https://www.instagram.com/brexhq/",
  },
  linkedin: {
    name: "Linkedin",
    url: "https://www.linkedin.com/company/brexhq/",
  },
  wikipedia: {
    name: "Wikipedia",
    url: "https://en.wikipedia.org/wiki/Brex/",
  },
  anchor: {
    name: "Anchor",
    url: "https://anchor.fm/brexintheblack/",
  },
  twitter: {
    name: "Twitter",
    url: "https://twitter.com/brexHQ/",
  },
  googlePodcasts: {
    name: "Google Podcasts",
    url: "https://podcasts.google.com/?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy9iNjEyNGQ4L3BvZGNhc3QvcnNz&ved=0CAAQ4aUDahcKEwjY9PLij-3oAhUAAAAAHQAAAAAQAQ&hl=en/",
  },
};
